import { render, staticRenderFns } from "./AssignUser.vue?vue&type=template&id=04f43146"
import script from "./AssignUser.vue?vue&type=script&lang=js"
export * from "./AssignUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports